class Snomed{
    /**
     *  Teste la présence et/ou la validité de la snomedBrowserLicence dans le localstorage
     */
    checkIfSnomedBrowerLicenceValid() {
        // Teste la présence de la licence
        if (localStorage.getItem("snomedBrowserLicence") == null) {
          // La clé "snomedBrowserLicence" n'existe pas dans le localstorage
          return false;
        }
        // Date du jour
        let currentDate = new Date();
        let timestampNow = currentDate.getTime();
        let timestampToNumberNow = parseInt(timestampNow);
        // Date d'acceptation de la licence
        let AcceptationtimestampToString = localStorage.getItem("snomedBrowserLicence")
        const Acceptationtimestamp = parseInt(AcceptationtimestampToString);
  
        // Ajouter 24 heure à la date d'acceptation de la licence en timestamp (milliseconds)
        let timestampLicencePlusTwentyFourHours = Acceptationtimestamp + 86400000;
  
        if (timestampToNumberNow > timestampLicencePlusTwentyFourHours) {
          // licence navigateur acceptée il y a plus de 24 heures
          // Non valide
          return false;
        }
        return true;
      }
    
      /**
       * Vérifier que l'utilisateur possede la licence Snomed de la termino à jour
       * @param {*} detailTermino details de la terminologie
       * @param {*} user details de l'utilisateur connecté
       */
      checkIfUserHasSnomedLicenceOfTheSnomedTermino(detailTermino, user) {

        if (user ==null || user.snomedAffiliateNumber == null || user.licences == null) {
          return false;
        }
        // Liste des licences de la termino
        let licencesTermino = detailTermino.licences;
        if(detailTermino.requiredLicences) {
          licencesTermino = licencesTermino.concat(detailTermino.requiredLicences);
        }
  
        // Liste des licences acceptées par l'utilisateur
        let licencesAccepted = user.licences;
  
        let allLicencesAccepted = true;
        for (let i = 0; i < licencesTermino.length; i++) {
          let licenceAccepted = undefined
          for (let j = 0; j < licencesAccepted.length; j++) {
            if (licencesTermino[i].uri === licencesAccepted[j].uri) {
              licenceAccepted = licencesAccepted[j];
              break;
            }
          }
  
          if (licenceAccepted) {          
              //recupération des dates licences de la termino
              let dateLicenceTerminoString = licencesTermino[i].updateDate;
              let dateLicenceTermino = Date.parse(dateLicenceTerminoString);
              let dateLicenceTerminoInt = parseInt(dateLicenceTermino);
  
              //recupération des dates licences de l'utilisateur
              let dateLicenceUserString = licenceAccepted.acceptanceDate;
              let dateLicenceUser = parseInt(dateLicenceUserString);
              if (dateLicenceTerminoInt > dateLicenceUser) {
                // Licence périmée (mise à jour après l'acceptation de l'utilisateur)
                allLicencesAccepted = false;
              }
          } else {
            allLicencesAccepted = false;
          }
        }
        return allLicencesAccepted;
      }
}
export default new Snomed();